import React from 'react';
import { AcceptBtn, CancelBtn } from '../../Common/NotificationButtons';

import localStorage from '../../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

export const Notification = props => {
    const TYPE = 'DELETE';
    const MESSAGES = {
        delete: strings.notification_message_delete,
        resend: strings.notification_message_resend
    };

    const NotificationTitle = props.type === TYPE ? strings.delete_patient.toUpperCase() : strings.resend_password.toUpperCase();
    const NotificationMessage = props.type === TYPE ? MESSAGES.delete : MESSAGES.resend;
    const MainBtnContent = props.type === TYPE ? strings.delete : strings.resend;

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="qf-notif-title-container">
                        <h1>{NotificationTitle}</h1>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="qf-notif-divider-line" />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="qf-notif-message-container">
                        <h3>{NotificationMessage}</h3>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <div className="qf-button-container rightAlign">
                        <CancelBtn title={strings.cancel} onclick={props.closeHandler} />
                    </div>
                </div>
                <div className="col-6">
                    <div className="qf-button-container leftAlign">
                        <AcceptBtn title={MainBtnContent} onclick={() => props.actionHandler()} />
                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Patients/components/Notifications.js